module.exports = __webpack_public_path__ + "3f6b0818fb372aab6a55d90da2be8bfe.woff";